import React, { useState, useEffect } from "react";
import "./BirthdayList.css";
import { getUsersSummary } from "../../../../../api/api";

const BirthdayList = ({ currentDate, dateRange, selectedView }) => {
  const [birthdays, setBirthdays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBirthdays = async () => {
      try {
        setLoading(true);
        const { startDate, endDate } = dateRange;

        // Устанавливаем время в начало и конец дня для корректного сравнения
        const periodStart = new Date(startDate);
        periodStart.setHours(0, 0, 0, 0);
        const periodEnd = new Date(endDate);
        periodEnd.setHours(23, 59, 59, 999);

        // Загружаем данные о пользователях
        const response = await getUsersSummary({
          isActive: true,
          pageSize: 1000,
        });

        // Фильтруем пользователей с днями рождения в выбранном периоде
        const filteredBirthdays = response.users.filter((user) => {
          if (!user.birth_date) return false;

          const birthDate = new Date(user.birth_date);
          const safeCurrentDate =
            currentDate instanceof Date ? currentDate : new Date();
          const currentYear = safeCurrentDate.getFullYear();

          // Создаем дату дня рождения в текущем году
          const birthdayThisYear = new Date(
            currentYear,
            birthDate.getMonth(),
            birthDate.getDate()
          );
          birthdayThisYear.setHours(0, 0, 0, 0);

          return (
            birthdayThisYear >= periodStart && birthdayThisYear <= periodEnd
          );
        });

        // Сортируем по дню рождения
        const sortedBirthdays = filteredBirthdays.sort((a, b) => {
          const dateA = new Date(a.birth_date);
          const dateB = new Date(b.birth_date);
          return (
            dateA.getDate() - dateB.getDate() ||
            dateA.getMonth() - dateB.getMonth()
          );
        });

        // Добавляем информацию о юбилеях
        const birthdaysWithJubilee = sortedBirthdays.map((user) => {
          const birthDate = new Date(user.birth_date);
          const safeCurrentDate =
            currentDate instanceof Date ? currentDate : new Date();
          const age = safeCurrentDate.getFullYear() - birthDate.getFullYear();
          const isJubilee = age % 5 === 0;

          return {
            ...user,
            age,
            isJubilee,
          };
        });

        setBirthdays(birthdaysWithJubilee);
      } catch (err) {
        console.error("Ошибка при загрузке дней рождений:", err);
        setError("Не удалось загрузить данные о днях рождения");
      } finally {
        setLoading(false);
      }
    };

    fetchBirthdays();
  }, [dateRange, currentDate]);

  const getViewTitle = () => {
    switch (selectedView) {
      case "day":
        return "Дни рождения сегодня";
      case "week":
        return "Дни рождения на этой неделе";
      case "month":
        return "Дни рождения в этом месяце";
      default:
        return "Дни рождения";
    }
  };

  if (loading) {
    return (
      <div className="birthday-list__loading">
        Загрузка данных о днях рождения...
      </div>
    );
  }

  if (error) {
    return <div className="birthday-list__error">{error}</div>;
  }

  if (birthdays.length === 0) {
    return (
      <div className="birthday-list__empty">
        Нет дней рождений за этот период
      </div>
    );
  }

  return (
    <div className="birthday-list">
      <h3 className="birthday-list__title">{getViewTitle()}</h3>
      <div className="birthday-list__content">
        {birthdays.map((user, index) => {
          const birthDate = new Date(user.birth_date);
          const formatDate = (date) => {
            return date.toLocaleDateString("ru-RU", {
              day: "2-digit",
              month: "2-digit",
            });
          };

          return (
            <div
              key={index}
              className={`birthday-list__item ${
                user.isJubilee ? "birthday-list__item--jubilee" : ""
              }`}
            >
              <div className="birthday-list__user-info">
                <span className="birthday-list__user-name">
                  {user.surname} {user.name} {user.patronymic}
                </span>
                <span className="birthday-list__user-age">
                  {user.isJubilee
                    ? `${user.age} ${
                        user.age % 10 === 1 && user.age % 100 !== 11
                          ? "год"
                          : user.age % 10 >= 2 &&
                            user.age % 10 <= 4 &&
                            (user.age % 100 < 10 || user.age % 100 >= 20)
                          ? "года"
                          : "лет"
                      } - Юбилей!`
                    : ""}
                </span>
              </div>
              <div className="birthday-list__birthday-info">
                <span className="birthday-list__birthday-date">
                  {formatDate(birthDate)}
                </span>
                <span className="birthday-list__birthday-gift">
                  {user.isJubilee ? "🎂" : "🎁"}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BirthdayList;
